/*
 * @Description: 大数据模块未付费用户限制访问
 * @Author: huamin.zhou
 */
export default {
  methods: {
    /**
     * 限制用户访问
     * 1、未登录用户访问跳转到登录页面
     * 2、个人用户提示开通企业版
     * 3、独董已到期提示续费
     */
    $_limitAccess_limitAccess() {
      if (!this.$storage.isLogin()) {
        this.$router.push({ path: '/login', query: { redirect_url: this.$route.fullPath } })
        return true
      }
      if (this.$auth.isOuterUser()) {
        if (this.$storage.getUserInfo().outerType === 1) {
          this.$xaConfirm({
            title: '小安提示',
            message: '您的账号暂未开通该功能权限<br />如需完整解锁该功能，可联系企业管理员',
            dangerouslyUseHTMLString: true,
            confirmButtonText: '我已知晓',
            showCancelButton: false,
            showClose: false
          })
            .then(() => { })
            .catch(() => { })
        } else {
          this.$store.commit('SHOWPERMISSIONDIALOG', 1)
        }
        return true
      }
      if (this.$auth.isIndependentDirectorUser() && this.$store.state.storeData.independentDirectorOverdue) {
        this.$store.commit('INDEPENDENTDIRECTORDIALOG', true)
        return true
      }
      return false
    }
  }
}
